import * as ActionName from '../action-names';

export default{
  eventDetailsLoadSuccess(details){
    return { type: ActionName.EVENT_DETAILS_LOAD_SUCCESS, details };
  },

  eventDetailsLoadFailed(){
    return { type: ActionName.EVENT_DETAILS_LOAD_FAILED };
  }
};
